export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10917.ecd1ae13.jpg";